import DoctorItem from './DoctorItem';

export default DoctorItem;
